/**
 * Klávesnice na telefonu.
 *
 * Na iOS se stránce o vysunuté klávesnici neřekne nic: `100vh`, `fixed`
 * i `inset-0` dál počítají s celou výškou, takže okno nebo lišta přilepená
 * dole skončí pod klávesnicí i s polem, do kterého se píše.
 *
 * Skutečnou výšku zná jenom `window.visualViewport`. Tenhle modul ji hlídá
 * a zapisuje do CSS proměnných:
 *
 *   --klavesnice   výška vysunuté klávesnice v px (0, když je schovaná)
 *   --vv-vyska     skutečná výška okna nad klávesnicí
 *
 * Cokoli přilepeného dolů (`fixed`/`sticky` s `bottom-0`) se o ně musí opřít
 * třídou `nad-klavesnici`, `lepive-nad-klavesnici` nebo `vyska-bez-klavesnice`
 * (viz src/index.css). Navíc se na `body` přidává `klavesnice-nahore`, což
 * schová spodní lištu, dokud se píše.
 *
 * Vzor: pm-app, src/lib/klavesnice.js. Vrací funkci, která hlídání ukončí.
 */

// Pod tímhle rozdílem to není klávesnice, ale schovávající se adresní řádek
// prohlížeče. Kdyby se lišta odlepovala i kvůli němu, poskakovala by při
// každém posunu stránky.
const PRAH_PX = 120;

export function sledujKlavesnici() {
  if (typeof window === "undefined") return () => {};

  const koren = document.documentElement;
  const vv = window.visualViewport;

  const nastav = () => {
    const vyskaOkna = vv ? vv.height : window.innerHeight;
    // `window.innerHeight` je celá plocha, `visualViewport.height` jen ta
    // viditelná nad klávesnicí. Rozdíl je klávesnice.
    const rozdil = Math.max(0, Math.round(window.innerHeight - vyskaOkna));
    const klavesnice = rozdil > PRAH_PX ? rozdil : 0;

    koren.style.setProperty("--klavesnice", `${klavesnice}px`);
    koren.style.setProperty("--vv-vyska", `${Math.round(vyskaOkna)}px`);
    document.body.classList.toggle("klavesnice-nahore", klavesnice > 0);
  };

  nastav();

  if (vv) {
    vv.addEventListener("resize", nastav);
    vv.addEventListener("scroll", nastav);
  }
  window.addEventListener("orientationchange", nastav);

  return () => {
    if (vv) {
      vv.removeEventListener("resize", nastav);
      vv.removeEventListener("scroll", nastav);
    }
    window.removeEventListener("orientationchange", nastav);
    koren.style.removeProperty("--klavesnice");
    koren.style.removeProperty("--vv-vyska");
    document.body.classList.remove("klavesnice-nahore");
  };
}
